import SearchAndOrder from '@core/interfaces/bpc-search-and-order';
import { FormModels } from './../../../../shared/interfaces/form-state';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { ValidationObserver } from 'vee-validate';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import { Order } from '@accounting/interfaces/order';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider.vue';
import ExtendedFilter from '@shared/components/filters/extended-filter/extended-filter.vue';
import CustomFilterSelector from '@shared/components/filters/custom-filter-selector/custom-filter-selector.vue';
import BulkMoveToTrashModal from '@shared/components/modals/bulk-move-to-trash-modal/bulk-move-to-trash-modal.vue';
import InvoiceGenerationForm from '@accounting/components/forms/invoice-generation-form/invoice-generation-form.vue';
import InvoiceGenerationModal from '@accounting/components/modals/invoice-generation-modal/invoice-generation-modal.vue';
import BulkRecoverModal from '@shared/components/modals/bulk-recover-modal/bulk-recover-modal.vue';

@Component({
  name: 'bpc-order-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-filter': StdFilter,
    'bpc-extended-filter': ExtendedFilter,
    ValidationObserver,
    'bpc-drawer-modal': DrawerModal,
    'bpc-std-form': StdForm,
    'bpc-custom-filter-selector': CustomFilterSelector,
    'bpc-bulk-move-to-trash-modal': BulkMoveToTrashModal,
    'bpc-invoice-generation-form': InvoiceGenerationForm,
    'bpc-invoice-generation-modal': InvoiceGenerationModal,
    'bpc-bulk-recover-modal': BulkRecoverModal,
  },
})
export default class OrderTable extends mixins(AbstractTable) {
  declare $refs: AbstractTable['$refs'] & {
    // resourceForm: InstanceType<typeof ResourceForm> & { saveEntity(): void };
    stdGenerateInvoicesForm: InstanceType<typeof StdForm> & {
      formModel: AnyEntity;
      formProvider: EntityFormProvider;
    };
    generateInvoiceForm: InstanceType<typeof InvoiceGenerationForm> & {
      formModel: AnyEntity;
    };
  };

  // PROPS
  @Prop(String) readonly title: string;
  @Prop(String) readonly subtitle: string;
  @Prop(Array) readonly filtersExcluded: string[];
  @Prop({ type: Boolean, default: true }) readonly showGenerateInvoiceAction: boolean;
  @Prop(Array) readonly accountingJournalsType: string[];
  @Prop({
    type: Array,
    default() {
      return ['default'];
    },
  })
  declare readonly selectConfigName: string[];

  // DATA
  public entity: Order = null;
  public entityName = 'order';
  public pluralEntityName = 'orders';
  public permissionEntityNameToUse = 'orders';
  public invoiceInDraftRoute = 'admin-invoices-in-draft';
  public invoicePaidAndToPayRoute = 'admin-invoices-paid-and-to-pay';
  public invoiceInToPayRoute = 'admin-invoices-to-pay';
  public creditNoteInDraftRoute = 'admin-credit-notes-in-draft';
  public creditNoteInToPayRoute = 'admin-credit-notes-to-pay';
  public creditNotePaidAndToPayRoute = 'admin-credit-notes-paid-and-to-pay';

  public customPageActions = {
    generateInvoices: {
      activated: false,
      type: 'action',
      icon: 'file-invoice', //'times',
      variant: 'primary',
      text: 'generate_invoices',
      show: false,
      event: 'generate-invoices',
      selectElements: true,
      tag: 'left',
      permissions: ['store'],
    },
  };

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'filtersLoaded',
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];

  readonly errorMessageText: string = 'global.generic.error_form_action';
  showInvoiceGenerationModal = false;
  searchAndOrder: SearchAndOrder = null;

  // COMPUTED
  get invoiceLink() {
    return this.$clientRouter.getClientUrl(`admin/main/invoices`);
  }

  get tenantId(): number {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  get pageActions() {
    return {
      ...this.customPageActions,
      ...this.defaultPageActions,
    };
  }

  // LIFECYCLE
  // created() {}
  mounted() {
    this.$root.$on('calculateTotalPrice', event => {
      setTimeout(() => {
        this.calculateTotalPrice();
      });
    });
    this.$root.$on('calculateBalance', event => {
      setTimeout(() => {
        // this.calculateBalance();
      });
    });
  }

  // destroyed() {}

  // updated() {}
  destroyed() {
    this.$root.$off('calculateTotalPrice');
    this.$root.$off('calculateBalance');
  }

  // METHODS
  setEntityAttributesAfterSave() {
    const newEntity = {} as Order;
    Object.keys(this.entity).forEach(key => {
      this.$set(newEntity, key, null);
    });

    this.$set(newEntity, 'status', this.entity.status);
    this.$set(newEntity, 'type', this.entity.type);
    this.$set(this.$refs.stdForm, 'formModel', newEntity);

    this.showForm = true;
    this.showDrawerSection = true;
  }

  onNew() {
    this.$bpcStorage.clear('order-items');
    this.entity = null;
    this.showForm = true;
    this.showDrawerSection = true;
    this.disabledForm = false;
  }

  onEdit(e, disabled = false) {
    this.$bpcStorage.clear('order-items');
    this.entity = e.item;
    this.showForm = true;
    this.showDrawerSection = true;
    setTimeout(() => {
      this.disabledForm = disabled;
    });
  }

  calculateTotalPrice() {
    const orderItems = this.$refs.stdForm.formModel.orderItems;
    let totalPrice: number = 0;
    let totalTax: number = 0;
    let totalPriceExcludingTax: number = 0;
    orderItems.forEach(item => {
      const discount = item.discount ? item.discount : 0;
      const discount_type = item.discount_type_value ? item.discount_type_value : 'percentage';
      let itemTotalPrice = 0;
      if (discount_type === 'percentage') {
        itemTotalPrice = item.price * item.quantity * (1 - discount / 100);
      } else {
        itemTotalPrice = item.price * item.quantity - discount;
      }
      totalPrice += itemTotalPrice;
      totalTax += itemTotalPrice - itemTotalPrice / (1 + item.tax_rate / 100);
      totalPriceExcludingTax = totalPrice - totalTax;
    });
    this.$set(
      this.$refs.stdForm.formModel,
      'total_price',
      Number.isNaN(totalPrice) ? null : totalPrice.toFixed(2),
    );
    this.$set(
      this.$refs.stdForm.formModel,
      'total_tax',
      Number.isNaN(totalTax) ? null : totalTax.toFixed(2),
    );
    this.$set(
      this.$refs.stdForm.formModel,
      'total_excluding_tax_price',
      Number.isNaN(totalPriceExcludingTax) ? null : totalPriceExcludingTax.toFixed(2),
    );
    // this.calculateBalance();
  }

  // calculateBalance() {
  //   const totalPrice = this.$refs.stdForm.formModel.total_price;
  //   const paid = this.$refs.stdForm.formModel.paid;
  //   this.$set(this.$refs.stdForm.formModel, 'balance', (totalPrice - paid).toFixed(2));
  // }

  extendUpdatePageActions() {
    if (this.config) {
      for (const activatedPageAction of this.config.data.activatedPageActions) {
        if (this.customPageActions[activatedPageAction]) {
          this.customPageActions[activatedPageAction].activated = true;
        }
      }
    }

    this.customPageActions.generateInvoices.show =
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed &&
      this.showGenerateInvoiceAction;

    // Check Permissions
    for (const activatedPageAction of this.config.data.activatedPageActions) {
      if (
        this.customPageActions[activatedPageAction] &&
        this.customPageActions[activatedPageAction]['permissions']
      ) {
        this.checkPermission(activatedPageAction);
      }
    }
  }

  customOnPageAction($event: string) {
    switch ($event) {
      case 'generate-invoices':
        this.onGenerateInvoices();
        break;
    }
  }

  onGenerateInvoices() {
    this.searchAndOrder = this.$refs.provider?.searchAndOrder;
    this.showInvoiceGenerationModal = true;
  }

  onCloseInvoiceGenerationModal() {
    this.showInvoiceGenerationModal = false;
  }
  onAllInvoicesGenerated() {
    this.$refs.provider.getEntities();
  }

  onLoadItems() {
    this.$store.dispatch('invoiceCounts/getInvoicesCount');
    this.$store.dispatch('invoiceCounts/getCreditNotesCount');

    setTimeout(() => {
      if (this.$refs.entityTable) {
        this.$refs.entityTable.$on('on-click-display', $event => {
          if (this.displayFieldsToSubscribe.includes($event.field)) {
            this.onEdit($event, true);
          }
        });
      }
    });
  }

  // Bulk soft delete modal (move to trash)
  showBulkMoveToTrashModal = false;
  onBulkSoftDelete() {
    this.showBulkMoveToTrashModal = true;
  }
  onCLoseBulkSoftDelete() {
    this.showBulkMoveToTrashModal = false;
  }
  onSuccessSoftDelete() {
    this.$refs.softDeleteConfirmationModal.onCloseModal();
    this.$refs.provider.getEntities();
  }
  // Here, put the same fields as you put in dataToShowForBulkTrashedEntity in your entity Service
  bulkMoveToTrashDataToShow = [['code', 'article'], ['date'], ['contact']];

  // Bulk restore modal (recover)

  showBulkRecoverModal = false;

  onBulkRecover() {
    this.showBulkRecoverModal = true;
  }

  onCLoseBulkRecover() {
    this.showBulkRecoverModal = false;
  }

  onSuccessBulkRecover() {
    this.$refs.provider.getEntities();
  }

  bulkRecoverDataToShow = [['code', 'article'], ['date'], ['contact']];
}
